@if (componentConfig?.rowData) {
  <mat-icon
    fontSet="material-icons-outlined"
    class="cursor-pointer empty-badge"
    [matBadge]="badgeValue"
    matBadgeSize="small"
    matBadgePosition="after"
    [ngClass]="iconClass"
    (click)="componentConfig?.callback?.(componentConfig!.rowData)"
  >
    chat
  </mat-icon>
}
